/* ============================================================
   PRODUCT METAFIELDS — Accordion JS
   File: assets/product-metafields.js

   Add to theme.liquid before </body>:
   <script src="{{ 'product-metafields.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  function initMetafieldAccordions() {
    const triggers = document.querySelectorAll('.metafield-accordion__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const panelId = trigger.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);

        if (!panel) return;

        // Toggle this accordion
        trigger.setAttribute('aria-expanded', String(!isExpanded));
        panel.setAttribute('aria-hidden', String(isExpanded));
      });
    });
  }

  // Init on DOM ready (works with Shopify's deferred rendering)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetafieldAccordions);
  } else {
    initMetafieldAccordions();
  }
})();
